import React from "react";
import { Link } from "react-router-dom";
import { FileText, Send, Briefcase, ShieldCheck, ArrowUpRight } from "lucide-react";
import { PHOTO_BASE_KM117 } from "../lib/constants";

export default function SecretariaLanding() {
  return (
    <div data-testid="secretaria-landing" className="py-20">
      <section className="relative h-[40vh] min-h-[320px] flex items-end overflow-hidden -mt-20 mb-16">
        <img src={PHOTO_BASE_KM117} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-900 via-forest-900/60 to-forest-900/30" />
        <div className="container-page relative pb-12 text-cream-100">
          <div className="eyebrow !text-copaiba-300 mb-3">Secretaria Virtual</div>
          <h1 className="font-display text-5xl md:text-6xl leading-[1.02] max-w-3xl">
            Um canal direto com a <span className="italic text-copaiba-300">administração</span> da cooperativa.
          </h1>
        </div>
      </section>

      <div className="container-page grid md:grid-cols-3 gap-6 mb-16">
        <Link to="/secretaria/enviar" data-testid="secretaria-send-card" className="card-earthy block p-8 group">
          <FileText className="w-8 h-8 text-copaiba-700 mb-5" />
          <h2 className="font-display text-2xl text-forest-900">Enviar comunicado ou documento</h2>
          <p className="text-forest-900/75 mt-3 text-sm leading-relaxed">
            Cooperados e instituições podem enviar mensagens, solicitações e documentos diretamente para a secretaria
            da COOMFLONA. Anexe arquivos (PDF, Word, imagens) de até 10 MB.
          </p>
          <span className="mt-5 inline-flex items-center gap-1 text-sm text-forest-700 group-hover:text-copaiba-700">
            Acessar formulário <ArrowUpRight className="w-4 h-4" />
          </span>
        </Link>

        <Link to="/vagas" data-testid="secretaria-jobs-card" className="card-earthy block p-8 group">
          <Briefcase className="w-8 h-8 text-copaiba-700 mb-5" />
          <h2 className="font-display text-2xl text-forest-900">Vagas de emprego</h2>
          <p className="text-forest-900/75 mt-3 text-sm leading-relaxed">
            Oportunidades de trabalho na cooperativa, na Movelaria Anambé e em projetos da Flona do Tapajós —
            abertas para cooperados e não cooperados.
          </p>
          <span className="mt-5 inline-flex items-center gap-1 text-sm text-forest-700 group-hover:text-copaiba-700">
            Ver vagas abertas <ArrowUpRight className="w-4 h-4" />
          </span>
        </Link>

        <Link to="/secretaria/login" data-testid="secretaria-login-card" className="bg-forest-700 text-cream-100 block p-8 group hover:bg-forest-900 transition-colors">
          <ShieldCheck className="w-8 h-8 text-copaiba-300 mb-5" />
          <h2 className="font-display text-2xl">Acesso restrito</h2>
          <p className="text-cream-100/80 mt-3 text-sm leading-relaxed">
            Área exclusiva para secretários da cooperativa: gerenciar mensagens recebidas, vagas e candidaturas.
          </p>
          <span className="mt-5 inline-flex items-center gap-1 text-sm text-copaiba-300 group-hover:text-copaiba-500">
            Entrar <ArrowUpRight className="w-4 h-4" />
          </span>
        </Link>
      </div>

      <div className="container-page max-w-3xl text-center">
        <p className="text-forest-900/75 leading-relaxed">
          A Secretaria Virtual organiza todas as comunicações enviadas para a cooperativa em um único lugar — solicitações
          de declarações, ofícios institucionais, documentos contábeis ou consultas de cooperados e parceiros. Tudo é
          respondido pela nossa equipe de secretaria.
        </p>
      </div>
    </div>
  );
}
